import React from 'react';
import * as d3 from '../../../libraries/d3';
import DateHelper from '../../DateHelper/DateHelper';

export default class LinePath extends React.Component {
  constructor(props) {
    super(props)
    this.state = {};
  };

  componentWillUnmount(){
    var t = d3.transition()
      .duration(750)
      .ease(d3.easeLinear);

    d3.select(`.${this.props.detail.data_column_name.toLowerCase().replace(/ /g, "_")}`).transition(t).remove()
  }

  componentDidMount() {
    var lineGenerator = d3.line()
      .x((d) => this.props.xScale(this.props.xDateAccessor(d)))
      .y((d) => this.props.yScale(this.props.detail.data_type === 'percent' ? parseFloat(d[this.props.detail.data_column_name]) * 100 : parseInt(d[this.props.detail.data_column_name])))
      .curve(d3.curveMonotoneX)



    var line = this.props.bounds().append('path')
      .style("opacity", 0)
      .attr('d', lineGenerator(this.props.data))
      .attr('fill', 'none')
      .attr('stroke', this.props.detail.color)
      .attr('stroke-width', 2)
      .attr('class', `line-path ${this.props.detail.data_column_name.toLowerCase().replace(/ /g, "_")}`)

    this.props.detail.yoy ? line.style("stroke-dasharray", ("3, 3")) : null

    line.transition().duration(2500).ease(d3.easeLinear).style("opacity", 1)

    // Dots for points if we would like them
    // line
    // .attr('d', lineGenerator(this.props.data))
    // // if(this.props.data.length <= 31){
    // //   var dots = bounds.selectAll('.visible-path')
    // //               .data(this.props.data)
    // //               .enter()
    // //               .append('circle')
    // //               .attr('cx', d => this.props.xScale(this.props.xAccessor(d)))
    // //               .attr('cy', d => this.props.yScale(this.props.report_details.data_details.find(detail => detail.data_column_name === this.props.yAccessor).data_type === "percent" ? (d[this.props.yAccessor] * 100) : d[this.props.yAccessor]))
    // //               .attr('r', 3)
    // //               .attr('fill', dataDetail && dataDetail.color ? dataDetail.color : null)
    // // }
  };

  componentDidUpdate(prevProps) {
    let xScale = this.props.xAxisDetail ? d3.scaleTime().domain(d3.extent(this.props.data, (d) => DateHelper.parseDate(d[this.props.xAxisDetail.data_column_name], this.props.date_format))).nice().range([0, this.props.dimensions().boundedWidth]) : null
    let yScale = this.props.detail.data_type == 'percent' ? d3.scaleLinear().domain([0, 100]).nice().range([this.props.dimensions().boundedHeight, 0]) : d3.scaleLinear().domain([this.props.yMaxMinDetailndValue.min, this.props.yMaxMinDetailndValue.max]).nice().range([this.props.dimensions().boundedHeight, 0])

    var lineGenerator = d3.line()
      .x((d) => xScale(this.props.xDateAccessor(d)))
      .y((d) => yScale(this.props.detail.data_type === 'percent' ? parseFloat(d[this.props.detail.data_column_name]) * 100 : parseInt(d[this.props.detail.data_column_name])))
      .curve(d3.curveMonotoneX)

    var t = d3.transition()
      .duration(750)
      .ease(d3.easeLinear)

    var line = d3.select(`.${this.props.detail.data_column_name.toLowerCase().replace(/ /g, "_")}`)

    line
      .transition(t)
      .attr('d', lineGenerator(this.props.data))

    if (this.props.hiddenDetails.length && this.props.hiddenDetails.find(data_column_name => data_column_name === this.props.detail.data_column_name)) {
      line
        .transition(t)
        .style("opacity", 0)
    } else {
      line
        .transition(t)
        .style("opacity", 1)
    };
  };

  render() {
    return (
      null
    );
  };

};